import { 
  FIXED_COST_ARTICLES, 
  HOURLY_ARTICLE, 
  ERROR_TOOLTIP_TIMEOUT,
  VALIDATION_ERRORS,
  DEFAULT_HOURLY_WORK_TIME,
  DEFAULT_FIXED_UNITS
} from '../constants/itemDetails.constants';

export const createFieldValidator = (
  setShowTooltipError: (errors: Record<string, boolean>) => void
) => {
  const validateFieldWithTooltip = (fieldName: string, value: any): boolean => {
    if (!value || value === '' || value === null || value === undefined) {
      setShowTooltipError({ [`null${fieldName}`]: true });
      setTimeout(() => setShowTooltipError({ [`null${fieldName}`]: false }), ERROR_TOOLTIP_TIMEOUT);
      return false;
    }
    return true;
  };

  const validateArticleWithPricingTypeAndTooltip = (
    articleNumber: string,
    isHourlyPrice: boolean,
    isDailyPrice: boolean,
    isWeeklyPrice: boolean,
    isMonthlyPrice: boolean,
    isAgreementPrice: boolean
  ): boolean => {
    const isFixedCostArticle = FIXED_COST_ARTICLES.includes(articleNumber);

    if (isHourlyPrice && articleNumber !== HOURLY_ARTICLE) {
      setShowTooltipError({ invalidArticleForPricing: true });
      setTimeout(() => setShowTooltipError({ invalidArticleForPricing: false }), ERROR_TOOLTIP_TIMEOUT);
      return false;
    }

    if ((isDailyPrice || isWeeklyPrice || isMonthlyPrice || isAgreementPrice) && articleNumber === HOURLY_ARTICLE) {
      setShowTooltipError({ invalidArticleForPricing: true });
      setTimeout(() => setShowTooltipError({ invalidArticleForPricing: false }), ERROR_TOOLTIP_TIMEOUT);
      return false;
    }

    return true;
  };

  const clearValidationErrors = (showTooltipError: Record<string, boolean>) => {
    const errors = Object.values(VALIDATION_ERRORS);
    errors.forEach(error => {
      if (showTooltipError[error]) {
        setShowTooltipError({ [error]: false });
      }
    });
  };

  return {
    validateFieldWithTooltip,
    validateArticleWithPricingTypeAndTooltip,
    clearValidationErrors
  };
};

export const getAutoSetUnits = (
  articleNumber: string,
  isHourlyPrice: boolean
): string | null => {
  const isFixedCostArticle = FIXED_COST_ARTICLES.includes(articleNumber);

  if (isFixedCostArticle) {
    return DEFAULT_FIXED_UNITS;
  } else if (articleNumber === HOURLY_ARTICLE && isHourlyPrice) {
    return DEFAULT_HOURLY_WORK_TIME;
  }

  return null;
};
